import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutoposition = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.9403 6.2C14.7903 2.72 11.9203 0 8.47032 0C5.02032 0 2.15032 2.72 2.00032 6.2C1.94032 7.58 2.32032 8.87 3.00032 9.95C3.16032 10.19 3.49032 10.24 3.72032 10.06C3.95032 9.89 3.99032 9.56 3.84032 9.31C3.29032 8.42 3.00032 7.36 3.04032 6.24C3.16032 3.32 5.57032 1.04 8.46032 1.04C11.3503 1.04 13.7603 3.32 13.8803 6.24C13.9303 7.36 13.6303 8.42 13.0803 9.31C12.9303 9.56 12.9703 9.88 13.2003 10.06C13.4303 10.23 13.7603 10.19 13.9203 9.95C14.6103 8.87 14.9803 7.58 14.9203 6.2H14.9403Z",
		fill: "#232323"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.18951 6.5193C9.06951 6.2293 8.77951 6.0293 8.46951 6.0293C8.15951 6.0293 7.86951 6.2193 7.74951 6.5193L3.83951 16.1193C3.67951 16.5193 3.96951 16.9493 4.39951 16.9493C4.64951 16.9493 4.86951 16.7993 4.95951 16.5693L5.75951 14.5493H11.1895L11.9895 16.5693C12.0795 16.7993 12.2995 16.9493 12.5495 16.9493C12.9795 16.9493 13.2695 16.5193 13.1095 16.1193L9.19951 6.5193H9.18951ZM6.17951 13.4693L8.39951 7.8293V7.8093L8.46951 7.6093L8.52951 7.8093V7.8293L10.7595 13.4693H6.17951Z",
		fill: "#232323"
	})]
});
export default SvgAutoposition;
